<header class="protocol-header">
  <div class="protocol-title-block">
    <i class="fa-solid fa-circle-nodes protocol-title-icon" aria-hidden="true"></i>
    <h1 class="protocol-page-title">Protocol Report</h1>
  </div>
  <div class="protocol-header__controls">
    <div class="protocol-fleet-wrap">
      <app-dropdown
        [control]="fleetControl"
        [options]="fleetOptions"
        [label]="''"
        placeholder="Select fleet"
        dataId="protocol-report-fleet"
      ></app-dropdown>
    </div>
    <div class="protocol-product-wrap" aria-label="Product code selection">
      <span class="protocol-product-wrap__label">Product Code</span>
      <span class="protocol-product-wrap__divider" aria-hidden="true"></span>
      <app-dropdown
        [control]="productCodeControl"
        [options]="productCodeOptions"
        [label]="''"
        placeholder="Code"
        dataId="protocol-report-product-code"
      ></app-dropdown>
    </div>
    <button
      type="button"
      class="protocol-calendar-btn"
      aria-label="Open date range"
      (click)="onCalendarClick()"
    >
      <i class="fa-regular fa-calendar" aria-hidden="true"></i>
    </button>
  </div>
</header>

<section class="protocol-main-card" aria-labelledby="protocol-distribution-title">
  <div class="protocol-main-card__body">
    <div class="protocol-chart-side">
      <h2 id="protocol-distribution-title" class="protocol-section-title">Protocol Distribution</h2>
      <div class="protocol-chart-row">
        <div class="protocol-donut-wrap">
          <canvas id="protocolReportDonutChart" role="img" aria-label="Protocol distribution chart"></canvas>
          <div class="protocol-donut-center" aria-hidden="true">
            <p class="protocol-donut-center__value">{{ totalDevices | number }}</p>
            <p class="protocol-donut-center__label">Total Devices</p>
          </div>
        </div>
        <ul class="protocol-legend" aria-label="Protocol legend">
          @for (slice of protocolSlices; track slice.id) {
          <li class="protocol-legend__row">
            <span class="protocol-legend__dot" [style.background-color]="slice.color"></span>
            <span class="protocol-legend__name">{{ slice.label }}</span>
            <span class="protocol-legend__pct">{{ slice.pct }}%</span>
          </li>
          }
        </ul>
      </div>
    </div>

    <div class="protocol-vdivider" aria-hidden="true"></div>

    <div class="protocol-table-side">
      <div class="protocol-table-shell">
        <div class="protocol-table-toolbar">
          <div class="protocol-search">
            <i class="fa-solid fa-magnifying-glass protocol-search__icon" aria-hidden="true"></i>
            <input
              type="search"
              class="protocol-search__input"
              placeholder="Search Devices"
              [(ngModel)]="deviceSearch"
              (ngModelChange)="onSearchInput()"
              aria-label="Search devices"
            />
          </div>
          <div class="protocol-toolbar-actions">
            <button
              type="button"
              class="protocol-icon-btn"
              aria-label="Filter"
              (click)="onFilterClick()"
            >
              <i class="fa-solid fa-filter" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="protocol-icon-btn"
              aria-label="Download"
              (click)="onExportClick()"
            >
              <i class="fa-solid fa-download" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="protocol-table-scroll">
          <table class="protocol-table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Device ID</th>
                <th scope="col">Device SN</th>
                <th scope="col">VIN</th>
                <th scope="col">Protocol</th>
                <th scope="col">Vehicle Type</th>
                <th scope="col">Last Contact</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              @for (row of pagedDevices; track trackDevice($index, row); let i = $index) {
              <tr>
                <td>{{ globalRowOffset + i + 1 }}</td>
                <td>{{ row.deviceId }}</td>
                <td>{{ row.deviceSn }}</td>
                <td>{{ row.vin }}</td>
                <td>{{ row.protocol }}</td>
                <td>{{ row.vehicleType }}</td>
                <td>{{ row.lastContact }}</td>
                <td>{{ row.status }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>

        <nav class="protocol-pagination" aria-label="Table pagination">
          <button
            type="button"
            class="protocol-page-btn"
            aria-label="First page"
            [disabled]="currentPage <= 1"
            (click)="goFirst()"
          >
            <i class="fa-solid fa-angles-left" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="protocol-page-btn"
            aria-label="Previous page"
            [disabled]="currentPage <= 1"
            (click)="goPrev()"
          >
            <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
          </button>
          @for (p of [1, 2, 3]; track p) {
          @if (p <= pageCount) {
          <button
            type="button"
            class="protocol-page-btn protocol-page-btn--num"
            [class.protocol-page-btn--active]="currentPage === p"
            (click)="goPage(p)"
          >
            {{ p }}
          </button>
          }
          }
          <button
            type="button"
            class="protocol-page-btn"
            aria-label="Next page"
            [disabled]="currentPage >= pageCount"
            (click)="goNext()"
          >
            <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="protocol-page-btn"
            aria-label="Last page"
            [disabled]="currentPage >= pageCount"
            (click)="goLast()"
          >
            <i class="fa-solid fa-angles-right" aria-hidden="true"></i>
          </button>
        </nav>
      </div>
    </div>
  </div>
</section>
